import React from 'react';

import { DashboardReportsEmpAdmin } from 'src/components/dashboard';
import { useCurrentUserPermissions } from 'src/hooks/user';

import { NotFoundErrorPage } from '../not-found';

import { DashboardPeoPage } from './DashboardPeoPage';

export const DashboardPage: React.FC = () => {
  const { isEmployerAdmin, isPeoSuperAdmin, isPeoAdmin, isPeoPayrollProviderUser } =
    useCurrentUserPermissions();

  if (isEmployerAdmin) {
    return <DashboardReportsEmpAdmin />;
  }

  if (isPeoSuperAdmin || isPeoAdmin || isPeoPayrollProviderUser) {
    return <DashboardPeoPage />;
  }

  return <NotFoundErrorPage />;
};
